import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class QuantityButton extends Vue {

  @Prop({ default: 0 }) maxValue;
  @Prop({ default: 0 }) minValue;
  @Prop({ default: 1 }) initialValue;

  currentValue = 0;

  mounted() {
    this.initialValue < this.minValue
      ? (this.currentValue = this.minValue)
      : (this.currentValue = this.initialValue);
  }

  _onChangeValue(val) {
    if (val >= 0) {
      if (this.maxValue) {
        this.currentValue + val <= this.maxValue ? (this.currentValue += val) : false;
      } else {
        this.currentValue += val;
      }
    } else {
      this.currentValue + val >= this.minValue ? (this.currentValue += val) : false;
    }
    this.$emit("change-value", this.currentValue);
  }
}